// Handle smooth scrolling for anchor links
document.addEventListener('DOMContentLoaded', function() {
  // Handling links with data-scroll-to attribute
  document.querySelectorAll('[data-scroll-to]').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('data-scroll-to');
      scrollToElement(targetId);
    });
  });
  
  // Function to handle scrolling to an element
  function scrollToElement(targetId) {
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      // Get any fixed header height to offset the scroll
      const headerOffset = document.querySelector('header') ? document.querySelector('header').offsetHeight : 0;
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset - 20; // 20px additional padding
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    } else {
      // If element doesn't exist yet, try again after a delay
      setTimeout(() => {
        scrollToElement(targetId);
      }, 500);
    }
  }
  
  // Handle direct hash navigation (like when loading page with #product-reviews in URL)
  if (window.location.hash) {
    const targetId = window.location.hash.substring(1); // Remove the # character
    
    // Wait for content to load
    setTimeout(() => {
      scrollToElement(targetId);
    }, 1000);

    // Also set up a mutation observer to detect when reviews might be loaded
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          // Check if our target element exists now
          if (document.getElementById(targetId)) {
            scrollToElement(targetId);
            observer.disconnect(); // Stop observing once we've found our element
          }
        }
      });
    });

    // Start observing the document with the configured parameters
    observer.observe(document.body, { childList: true, subtree: true });
  }
}); 